import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border: #bfbfbf 1px solid;
  border-radius: 50%;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  line-height: 25px;
  cursor: pointer;
  font-size: 1em;
  user-select: none;
    &:hover {
        ${Input} ~ ${Checkmark} {
  background-color: #ccc;
}
    }
    ${Input}:checked ~ ${Checkmark} {
  background-color: #fff;
}

${Input}:checked ~ ${Checkmark}:after {
  display: block;
}

${Checkmark}:after {
    top: 3px;
    left: 3px;
    width: 17px;
    height: 17px;
	border-radius: 50%;
	background: #4bc2ca;
}
`;

const RadioButton = props => {
  const { htmlFor, children, name, isChanged, isChecked } = props;
  // if (isChecked) {
  //   document.getElementById(htmlFor).defaultChecked = true;
  // }

  const handleChange = () => {
    isChanged();
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <Label htmlFor={htmlFor}>
      {children}
      <Input
        defaultChecked={isChecked}
        id={htmlFor}
        name={name}
        onChange={handleChange}
        type="radio"
      />
      <Checkmark />
    </Label>
  );
};

RadioButton.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isChanged: PropTypes.func,
  isChecked: PropTypes.bool,
};

RadioButton.defaultProps = {
  isChanged: () => {},
  isChecked: false,
};

export default RadioButton;
